import { render, staticRenderFns } from "./curriculumName.vue?vue&type=template&id=159c724e&scoped=true"
import script from "./curriculumName.vue?vue&type=script&lang=js"
export * from "./curriculumName.vue?vue&type=script&lang=js"
import style0 from "./curriculumName.vue?vue&type=style&index=0&id=159c724e&prod&lang=less&scoped=true"
import style1 from "./curriculumName.vue?vue&type=style&index=1&id=159c724e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159c724e",
  null
  
)

export default component.exports